import { render } from "./canvasExample.vue?vue&type=template&id=6a5bdf78&scoped=true"
import script from "./canvasExample.vue?vue&type=script&lang=js"
export * from "./canvasExample.vue?vue&type=script&lang=js"

import "./canvasExample.vue?vue&type=style&index=0&id=6a5bdf78&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5bdf78"]])

export default __exports__